import React from "react";
import styled, { css } from "styled-components";

type ContainedButtonStyleProps = React.HTMLProps<HTMLButtonElement> & {
  width: string;
  color: string;
  block?: boolean;
};

export const ContainedButtonStyle = styled.button<ContainedButtonStyleProps>`
  border: none;
  cursor: pointer;
  border-radius: 5px;
  height: 50px;
  min-width: 64px;
  padding: 15px 13px;
  font-size: 0.9375rem;
  font-family: "Mangueira bold";

  ${({ width }) =>
    width &&
    css`
      width: ${width};
    `}
  ${({ block }) =>
    block &&
    css`
      width: 100%;
    `}
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;

  span {
    flex: 1;
    justify-self: center;

    i {
      font-size: 20px;
    }
  }

  i {
    font-size: 20px;
  }

  transition: 0.5s opacity, 0.5s background-color, 0.5s border-color, 0.5s color;
  background-color: ${(props) =>
    props.color ? props.color : props.theme.colors.lightBlue};
  color: #fff;

  &:hover {
    opacity: 0.85;
  }

  &:focus {
    box-shadow: none;
    outline: none !important;
  }
  &:not(:disabled):not(.disabled):active {
    background-color: ${(props) => props.color};
    opacity: 0.85;
    box-shadow: none;
  }
  &:not(:disabled):not(.disabled):active:focus {
    background-color: ${(props) => props.color};
    opacity: 0.85;
    box-shadow: none;
    border-color: ${(props) => props.color};
  }

  &:disabled {
    cursor: no-drop;
    background-color: rgb(128, 132, 149);
    border-color: rgb(128, 132, 149);
    color: #fff;
  }
`;

export const TrailingIconContainer = styled.div`
  position: absolute;
  margin: 0 10px 0 10px;
  right: 0;
`;

export const LeadingIconContainer = styled.div`
  position: absolute;
  margin: 0 10px 0 10px;
  left: 0;
`;
